import React, {useState, Fragment} from 'react';
import {Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button as MuiButton} from '@mui/material';

import {Button} from '../main/Styles/Toolbar.jsx';
import {Styles} from '../main/Styles/Styles.js';

import {CONNECTION_STATE} from './StateConstants.jsx';
import PropTypes from 'prop-types';

const UpdateAvailableStep = (props) => {
  UpdateAvailableStep.propTypes = {
    setState: PropTypes.func.isRequired
  };

  const [isCancel, setCancel] = useState(false);

  return (
    <Fragment>
      <div>
        Updates are available for your scanner.<p/>
        It is highly recommended that you proceed with updating your scanner.<p/>
        The update ensures that the scanner is compatible with the latest browsers and operating systems.<p/>&nbsp;<p/>
        Please click CONTINUE to update the scanner or click CANCEL to abort the update.
      </div>
      <div>
        &nbsp;<p/>
        <MuiButton variant="contained" color="primary"
          onClick={() => {
            props.setState(CONNECTION_STATE.UPDATE_EXECUTING);
          }}
        >
          Continue
        </MuiButton>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <MuiButton variant="contained" color="primary"
          onClick={() => {
            setCancel(true);
          }}
        >
          Cancel
        </MuiButton>
      </div>

      <Dialog
        sx={{'& .MuiDialog-paper': {width: '80%', maxHeight: 435}}}
        maxWidth="xs"
        open={isCancel}
      >
        <DialogContent sx={Styles}>
          <DialogContentText>
            <b>Cancel Scanner Update</b><p/>
            Updating your scanner is highly recommended. <p/>
            Canceling the update may affect your scanner&apos;s operation.<p/><p/>
            Do you want to cancel the scanner update?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-start" }}>
          <Button onClick={() =>{
            props.setState(CONNECTION_STATE.UPDATE_HAS_CANCELED);
          }} color="primary" variant="contained">
            Yes
          </Button>
          <Button onClick={() =>{
            setCancel(false);
          }} color="primary" variant="contained">
            No
          </Button>
        </DialogActions>
      </Dialog>

    </Fragment>
  );
};

export default UpdateAvailableStep;
